import React, { createContext, useContext, useState } from 'react';
const INITIAL_AUTO_SCALE = 0;
const DEFAULT_AUTO_SCALE = 1;
const TagsAutoScaleContext = createContext(null);
export const AutoScaleProvider = ({ children }) => {
    const [globalAutoScale, setGlobalAutoScale] = useState(INITIAL_AUTO_SCALE);
    const [customAutoScale, setCustomAutoScale] = useState({});
    const handleSetGlobalAutoScale = (value = globalAutoScale || DEFAULT_AUTO_SCALE) => {
        setGlobalAutoScale(value);
    };
    const handleSetCustomAutoScale = (key, value) => {
        const prevValue = customAutoScale[key];
        const defaultValue = prevValue === 0 ? DEFAULT_AUTO_SCALE : globalAutoScale;
        const nextValue = value !== undefined ? value : defaultValue;
        setCustomAutoScale({ ...customAutoScale, [key]: nextValue });
    };
    const handleLinkToGlobalAutoScale = (key) => {
        if (customAutoScale[key] === undefined)
            return;
        const nextCustomAutoScale = { ...customAutoScale };
        delete nextCustomAutoScale[key];
        setCustomAutoScale(nextCustomAutoScale);
    };
    const getAutoScale = (id) => {
        if (customAutoScale[id] !== undefined) {
            return { isLinked: false, value: customAutoScale[id] };
        }
        return { isLinked: true, value: globalAutoScale };
    };
    const resetAutoScale = () => {
        setGlobalAutoScale(INITIAL_AUTO_SCALE);
        setCustomAutoScale({});
    };
    return (React.createElement(TagsAutoScaleContext.Provider, { value: {
            setGlobalAutoScale: handleSetGlobalAutoScale,
            setCustomAutoScale: handleSetCustomAutoScale,
            link: handleLinkToGlobalAutoScale,
            unlink: handleSetCustomAutoScale,
            getAutoScale,
            resetAutoScale
        } }, children));
};
export const useAutoScale = () => useContext(TagsAutoScaleContext);
